import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { RicercatoreFulltextPratiche } from '../../../pratica/creazione/ricercatore-fulltext-pratiche.component';
import { OperationsService } from 'src/app/core/services/operations.service';
import { Router } from '@angular/router';
import { FrontEndMapping } from 'src/app/core/configuration/front-end-mapping';
import { PraticaBase } from 'src/app/common/models/pratica/pratica-base';
import { PraticaSelect } from 'src/app/common/models/pratica/intestazione-pratica/pratica-select';
import { SearchPraticheComponent } from '../../../input-component/searchPratiche/search-pratiche.component';
import { PraticaLight } from 'src/app/common/models/pratica/pratica-light';
import { SearchResponse } from 'src/app/common/models/dto/search-response';

@Component({
  selector: 'app-ricerca-precedenti-core',
  templateUrl: './ricerca-precedenti-core.component.html',
  styleUrls: ['./ricerca-precedenti-core.component.css']
})
export class RicercaPrecedentiCoreComponent extends RicercatoreFulltextPratiche implements OnInit,OnChanges {
 
  @Input() pratica: PraticaBase;
  @Input() disableSave: boolean;
  praticheCorrelate: PraticaSelect[];
  pratichePrecedenti: PraticaSelect[] = [];
  praticaCopyInfo: PraticaSelect = null;
  resetPrecedenti: boolean;
  idFormPratica: string;
  classificazioniCopyPratica
  @ViewChild('searchPratiche') searchPraticheInput: SearchPraticheComponent;
  afterViewInit: boolean = false;
  onPagePrecedenti: boolean = false;
  @Output() onReturn: EventEmitter<boolean> = new EventEmitter<boolean>();


  constructor(protected operationService: OperationsService, private router: Router, private frontEndMapping: FrontEndMapping) {
    super(operationService)
  }

  ngOnInit() {
    this.pratiche = [];
  }

  ngOnChanges(changes: SimpleChanges) {
    this.pratiche = [];
    this.searchPraticheInput?.onResetSearchText();
  }

  addPratichePrecedenti(pratica: PraticaSelect) {
    this.resetPrecedenti = false;
    if (pratica.selected) {
      this.pratichePrecedenti.push(pratica);
    } else {
      this.pratichePrecedenti = this.pratichePrecedenti.filter(el => el.id !== pratica.id);
      if (this.praticaCopyInfo.id === pratica.id) {
        this.praticaCopyInfo = null;
        this.classificazioniCopyPratica = [];
      }
    }
  }

  getPraticheRetrieved(searchResponse: SearchResponse, reload: boolean = false) {
    if (searchResponse) {
      if (!reload) {
        this.pratiche = new Array<PraticaLight>();
      }
      if (searchResponse.pratiche.length > 0) {
        this.searchResponse = searchResponse;
        this.pratiche = this.pratiche.concat(searchResponse.pratiche);
      } else {
        this.pratiche = [];
      }
    } else {
      this.pratiche = new Array<PraticaLight>();
    }
  }

  reloadSearch() {
    let parziale: number = this.pratiche.length;
    this.searchPraticheInput.reloadCallback(parziale );
  }

  resetPrec() {
    this.pratichePrecedenti = [];
    this.classificazioniCopyPratica = [];
    this.resetPrecedenti = true;
  }

  salvaPrecedenti() {
    this.salvePratichePrecedentiObs(this.pratichePrecedenti, this.pratica, null).subscribe(response => {
      this.onReturn.emit(true);
    });
    
  }

}
